import posthog from "posthog-js";
import type { IPosthogSdk } from "./types";

// PosthogSDKReal is the production implementation — thin wrapper over posthog-js.
// setFlag is not supported in prod (flags come from PostHog itself).
export class PosthogSDKReal implements IPosthogSdk {
  constructor(
    private readonly apiKey: string,
    private readonly apiHost?: string,
  ) {}

  async init(): Promise<void> {
    posthog.init(this.apiKey, {
      // Leave api_host undefined to let posthog-js use its default
      // (https://us.i.posthog.com). Override via POSTHOG_HOST for EU region or
      // a self-hosted reverse-proxy path.
      ...(this.apiHost ? { api_host: this.apiHost } : {}),
      defaults: "2025-05-24",
    });
    await posthog.featureFlags.ensureFlagsLoaded();
  }

  isFlagEnabled(flagName: string): boolean | undefined {
    return posthog.isFeatureEnabled(flagName);
  }

  onFeatureFlags(handler: () => void): () => void {
    return posthog.featureFlags.onFeatureFlags(handler);
  }

  setFlag(): void {
    throw new Error("Cannot set flags in production mode");
  }

  identify(id: string, email: string): void {
    posthog.identify(id, { email });
  }

  capture(event: string, properties?: Record<string, unknown>): void {
    posthog.capture(event, properties);
  }

  logout(): void {
    posthog.reset();
  }
}
